import React from 'react';

let CategoryClickRow = class extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { click } = this.props;
        return (
            <tbody>
                <tr>
                    <td>{click.Rate}</td>
                    <td>{click.CategoryName}</td>
                    <td>{click.ClicksCount}</td>
                </tr>
            </tbody>);
    }
}

export default CategoryClickRow;


// WEBPACK FOOTER //
// ./src/components/analytics/categoryClicks/CategoryClickRow.jsx